module.exports = __webpack_public_path__ + "img/two.bd8f1ff6.png";